import { BaseEntity } from '@/actions/dtos/baseEntity';

export interface Organization extends BaseEntity {
  name: string;
  onboarded: boolean;
}

export interface OrganizationDetails extends BaseEntity, OrganizationDetailsData {}

export interface OrganizationDetailsData {
  website: string | null;
  industrySector: IndustrySector | null;
  companySize: CompanySize | null;
  description: string | null;
  address: AddressData | null;
}

export interface AddressData {
  addressLineOne: string | null;
  addressLineTwo: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
}

export interface Person extends BaseEntity, PersonDetailsData {
  email: string;
  onboarded: boolean;
  enabled: boolean;
}

export interface PersonDetailsData {
  firstname: string;
  lastname: string;
  experienceLevel: ExperienceLevel | null;
  phone: string | null;
  jobTitle: JobTitle | null;
  discoveryMethod: DiscoveryMethod | null;
  newsletterAgreement?: boolean;
}

// Order is important to define the role priority.
export enum MemberRole {
  MEMBER = 'Mitglied',
  ADMIN = 'Administrator',
  OWNER = 'Inhaber',
}

export interface Member extends BaseEntity {
  person: Person;
  role: MemberRole;
}

export enum DiscoveryMethod {
  RECOMMENDATION = 'RECOMMENDATION',
  INVITATION = 'INVITATION',
  AI_CHAT = 'AI_CHAT',
  SEARCH_ENGINE = 'SEARCH_ENGINE',
  LINKED_IN = 'LINKED_IN',
  ADVERTISEMENT = 'ADVERTISEMENT',
  OTHER = 'OTHER',
}

export enum ExperienceLevel {
  NONE = 'NONE',
  LITTLE = 'LITTLE',
  SOME = 'SOME',
  MUCH = 'MUCH',
}

export enum JobTitle {
  SALES_EMPLOYEE = 'SALES_EMPLOYEE',
  SALES_MANAGER = 'SALES_MANAGER',
  VP_CEO = 'VP_CEO',
  ADMIN = 'ADMIN',
  FINANCE = 'FINANCE',
  MARKETER = 'MARKETER',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  CUSTOMER_SUPPORT_SUCCESS = 'CUSTOMER_SUPPORT_SUCCESS',
  OTHER = 'OTHER',
}

export enum CompanySize {
  SOLO = 'SOLO',
  NANO = 'NANO',
  MICRO = 'MICRO',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  HUGE = 'HUGE',
  ENTERPRISE = 'ENTERPRISE',
  GLOBAL = 'GLOBAL',
}

export enum IndustrySector {
  AGRICULTURE = 'AGRICULTURE',
  MINING = 'MINING',
  MANUFACTURING = 'MANUFACTURING',
  RENEWABLE_ENERGY = 'RENEWABLE_ENERGY',
  CONVENTIONAL_ENERGY = 'CONVENTIONAL_ENERGY',
  WATER_WASTE_MANAGEMENT = 'WATER_WASTE_MANAGEMENT',
  CONSTRUCTION = 'CONSTRUCTION',
  CRAFTS = 'CRAFTS',
  WHOLESALE_RETAIL = 'WHOLESALE_RETAIL',
  TRANSPORTATION_STORAGE = 'TRANSPORTATION_STORAGE',
  HOSPITALITY_GASTRONOMY = 'HOSPITALITY_GASTRONOMY',
  IT_SERVICES_SOFTWARE = 'IT_SERVICES_SOFTWARE',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  MEDIA_PUBLISHING = 'MEDIA_PUBLISHING',
  FINANCE_INSURANCE = 'FINANCE_INSURANCE',
  REAL_ESTATE = 'REAL_ESTATE',
  BUSINESS_LEGAL_TAX_CONSULTING = 'BUSINESS_LEGAL_TAX_CONSULTING',
  ADMINISTRATIVE_SUPPORT = 'ADMINISTRATIVE_SUPPORT',
  RESEARCH_DEVELOPMENT = 'RESEARCH_DEVELOPMENT',
  PUBLIC_ADMINISTRATION_DEFENSE = 'PUBLIC_ADMINISTRATION_DEFENSE',
  EDUCATION = 'EDUCATION',
  HEALTHCARE = 'HEALTHCARE',
  SOCIAL_SERVICES = 'SOCIAL_SERVICES',
  ARTS_ENTERTAINMENT = 'ARTS_ENTERTAINMENT',
  OTHER = 'OTHER',
}
